// extracted by mini-css-extract-plugin
export var sliderRange = "_pl-2";
export var sliderRoot = "_pl-0";
export var sliderThumb = "_pl-3";
export var sliderTrack = "_pl-1";